
export const getRoleFromStorage = () => {
  try {
    return localStorage.getItem("user_role") || null;
  } catch (error) {
    console.error("Error reading role from local storage:", error);
    return null;
  }
};
export const getRolesFromStorage = () => {
  try {
    const roles = localStorage.getItem("user_roles");
    return roles ? JSON.parse(roles) : [];
  } catch (error) {
    console.error("Error reading roles from local storage:", error);
    return [];
  }
};

export const hasRole = (role) => {
  const roles = getRolesFromStorage();
  return roles.includes(role);
};

export const hasAnyRole = (rolesToCheck) => {
  const roles = getRolesFromStorage();
  return rolesToCheck.some(role => roles.includes(role));
};

export const hasAllRoles = (rolesToCheck) => {
  const roles = getRolesFromStorage();
  return rolesToCheck.every(role => roles.includes(role));
};

export const saveRolesToStorage = (roles, primaryRole) => {
  try {
    localStorage.setItem("user_roles", JSON.stringify(roles));
    if (primaryRole) {
      localStorage.setItem("user_role", primaryRole);
      switch(primaryRole){
        case 'business' : localStorage.setItem('isBusiness' , 'true') ; break;
        case 'admin' : localStorage.setItem('isAdmin' , 'true') ; break ;
        default : localStorage.setItem('isUser' , 'true') ; break ;
      }
    }
  } catch (error) {
    console.error("Error saving roles to local storage:", error);
  }
};

export const clearRoleFromStorage = () => {
  try {
    localStorage.removeItem("user_role");
    localStorage.removeItem("user_roles");
  } catch (error) {
    console.error("Error clearing roles from local storage:", error);
  }
};

/**
 * Get user type based on stored roles
 * @returns {'business'|'normal'|'admin'|null} User type or null
 */
export const getUserType = () => {
  if (hasRole("ADMIN")) return "admin";
  if (hasRole("COMPANY_USER")) return "business";
  if (hasRole("NORMAL_USER")) return "normal";
  return null;
};

/**
 * Check if user is a business user
 * @returns {boolean}
 */
export const isCompanyUser = () => hasRole("COMPANY_USER");

/**
 * Check if user is a normal user
 * @returns {boolean}
 */
export const isNormalUser = () => hasRole("NORMAL_USER");

/**
 * Check if user is an admin
 * @returns {boolean}
 */
export const isAdmin = () => hasRole("ADMIN");
